import React from 'react';
import { Link } from 'react-router-dom';

// Fuente única (Res. MinTIC 1519/2020): canales de atención en el portal de ICETEX.
const CANALES_URL = 'https://web.icetex.gov.co/atencion-y-servicios-a-la-ciudadania/canales-de-atencion/canales-digitales';

const TermsCTA = () => {
  return (
    <div className="mt-[50px]">
      <div
        className="text-center rounded-[30px] border-2 border-icetex/20"
        style={{
          background: 'linear-gradient(135deg, #e8f4ff 0%, #d4e9ff 100%)',
          padding: '50px 40px',
        }}
      >
        <h3 className="text-texto-oscuro font-extrabold text-[2rem] mb-4">
          ¿Tienes preguntas sobre estos términos?
        </h3>
        <p className="text-texto-sec mx-auto text-[1.1rem] leading-[1.8] mb-[30px] max-w-[700px]">
          Nuestro equipo está disponible para resolver cualquier duda que tengas sobre estos términos y condiciones
        </p>
        <div className="flex justify-center flex-wrap gap-5">
          <a
            href={CANALES_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block font-bold uppercase no-underline text-white px-[40px] py-4 rounded-full text-[1rem] tracking-[0.5px] bg-gradient-to-br from-icetex to-icetex-dark hover:-translate-y-[3px] transition-all duration-300"
            style={{ boxShadow: '0 6px 20px rgba(0, 63, 129, 0.3)' }}
          >
            Contáctanos
          </a>
          <Link
            to="/"
            className="inline-block font-bold uppercase no-underline text-icetex bg-white border-2 border-icetex px-[40px] py-4 rounded-full text-[1rem] tracking-[0.5px] hover:bg-icetex hover:text-white hover:-translate-y-[3px] transition-all duration-300"
          >
            Ir al Inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsCTA;
